module.exports = __webpack_public_path__ + "img/sMahPhe_350x350.b783ef3e.jpg";